module.exports = __webpack_public_path__ + "static/media/jan.johansson.44e03c65.jpg";